export default __webpack_public_path__ + "static/media/wa-1717.e2208730.jpg";